import { RcPage, RcSection } from "@financeone/core-ui";
import React from "react";
import { Link } from "react-router-dom";
import RouteTable from "../../../manifold/RouteTable";
import { EnumDataGrid, EnumDataGridRow } from "../../utils/EnumDataGrid/EnumDataGrid";

const enumRows: EnumDataGridRow[] = [
    { value: "renting", description: "Renting" },
    { value: "owned", description: "Owned" },
    { value: "boarding", description: "Boarding" },
    { value: "temporary", description: "Temporary" },
];

const ResidentialStatusEnum: React.FunctionComponent = () => {
    return (
        <RcPage title="Residential Status Types" description="Enumerated Types">
            <RcSection title="Description">
                <p>A list of accepted values for the Residential Status field.</p>
            </RcSection>
            <RcSection>
                <EnumDataGrid enumRows={enumRows} />
            </RcSection>
            <RcSection title="Used By">
                <ul>
                    <li>
                        <Link to={RouteTable.SharedModelTypes.ResidentialModel}>Residential</Link>
                    </li>
                </ul>
            </RcSection>
        </RcPage>
    );
};

export default ResidentialStatusEnum;
